// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"Choose_inputGroup__J_-dZ","searchBox":"Choose_searchBox__CIjC5","label":"Choose_label__16hB_","inputGroupHeader":"Choose_inputGroupHeader__1BhwD"};